import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import '../CancelDialog.css'
import { onClickCloseTab } from '../handler/ProjectManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CancelTabsDialog({argsAll}) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const onCloseDialogReject = (event, reason) => {
        argsAll.setIsConfirmCancelTabs(false);
    };
    return (
        <Dialog
            open={argsAll.isConfirmCancelTabs}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{trI18n('COMMSG043')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onClickCloseTab(argsAll)}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
